const item = {
  width: "100%",
  padding: 0,
  cursor: "pointer",
};

// function itemContent(theme, ownerState) {
//   const { palette, typography, transitions, functions } = theme;
//   const { active, miniSidenav, name, nested } = ownerState;

//   const { dark, gradients ,white,transparent,menuSelect} = palette;
//   const { size, fontWeightMedium, fontWeightRegular } = typography;
//   const { pxToRem, rgba } = functions;

//   return {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     width: "100%",
//     padding: `${pxToRem(7.2)} ${pxToRem(16)}`,
//     margin: `0 ${pxToRem(16)} 0 ${pxToRem(35)} 0 ${pxToRem(16)} 0 ${pxToRem(10.6)}`,
//     userSelect: "none",
//     position: "relative",
//     "& span": {
//       // color: active ? dark.main : rgba(gradients.dark.state, 0.7),
//       background: active ? menuSelect.main : transparent.main,
//       borderRight: active && "4px solid #fff",
//       padding:"5px 5px 5px 20px",
//       borderRadius:"15px 0 0 15px",
//       marginRight:"-15px",
//       color: white.main,
//       fontWeight: active ? fontWeightMedium : fontWeightRegular,
//       // fontSize: size.sm,
//       fontSize:"13px",
//       opacity: miniSidenav ? 0 : 1,
//       transition: transitions.create(["opacity", "color"], {
//         easing: transitions.easing.easeInOut,
//         duration: transitions.duration.standard,
//       }),
//     },

//     "&::before": {
//       content: () => {
//         if (nested) {
//           return nested && miniSidenav && `"${name[0]}"`;
//         }

//         return miniSidenav ? `"${name[0]}"` : '""';
//       },
//       width: () => {
//         if (!miniSidenav) {
//           return active ? pxToRem(8) : pxToRem(5);
//         }

//         return 0;
//       },
//       height: () => {
//         if (!miniSidenav) {
//           return active ? pxToRem(8) : pxToRem(5);
//         }

//         return 0;
//       },
//       // backgroundColor: active ? dark.main : rgba(gradients.dark.state, 0.5),
//       // color: active ? dark.main : rgba(gradients.dark.state, 0.5),
//        color: white.main,
//       fontWeight: active ? fontWeightMedium : fontWeightRegular,
//       display: "flex",
//       alignItems: "center",
//       position: "absolute",
//       top: "50%",
//       transform: "translateY(-50%)",
//       // left: pxToRem(-18),
//       opacity: 1,
//       borderRadius: "50%",
//       fontSize: size.sm,
//       borderLeft: `2px solid ${active ? white.main : rgba(white.main, 0.5)}`, // Border on the left
//     borderBottom: `2px solid ${active ? white.main : rgba(white.main, 0.5)}`,
//     },
//   };
// }

function itemContent(theme, ownerState) {
  const { palette, typography, transitions, functions } = theme;
  const { active, miniSidenav, name, nested } = ownerState;

  const { dark, gradients, white, transparent, menuSelect } = palette;
  const { size, fontWeightMedium, fontWeightRegular } = typography;
  const { pxToRem, rgba } = functions;

  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    right: pxToRem(-15),
    padding: `${pxToRem(7.2)} ${pxToRem(8)}`,
    margin: `0 ${pxToRem(16)} 0 ${pxToRem(30)} 0 ${pxToRem(16)} 0 ${pxToRem(20)}`,
    userSelect: "none",
    position: "relative",
    "& span": {
      background: active ? menuSelect.main : transparent.main,
       padding:"5px 5px 5px 20px",
      borderRight: active && "4px solid #fff",
      borderRadius: "20px 0 0 20px",
      marginLeft: "-11px",
      marginRight: pxToRem(10),
      // color: active ? dark.main : rgba(gradients.dark.state, 0.7),
      left: pxToRem(35),
      right: pxToRem(-10),
      color: white.main,
      fontWeight: active ? fontWeightMedium : fontWeightRegular,
      fontSize: "13px",
      opacity: miniSidenav ? 0 : 1,
      transition: transitions.create(["opacity", "color", "background"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },
    "&::before": {
      content: '""',
      position: "absolute",
      left: pxToRem(-5),
      top: "0",
      width: "2px",
      height: "100%",
      backgroundColor: "rgba(255, 255, 255, 0.3)",
      borderRadius: "0 10px 10px 0", // Adds a smooth curve
      transition: transitions.create(["background-color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: pxToRem(-5),
      bottom: "65%",
      width: "20px",
      height: "20px",
      borderBottom: "2px solid rgba(255, 255, 255, 0.3)",
      borderRadius: "0 0 0 15px", // Smooth bottom curve
      transform: "translateY(50%)",
      backgroundColor: "transparent",
      transition: transitions.create(["border-color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },
  };
}

function itemArrow(theme, ownerState) {
  const { typography, transitions, functions, palette } = theme;
  const { open, miniSidenav } = ownerState;

  const { dark, gradients, white } = palette;
  const { size } = typography;
  const { pxToRem, rgba } = functions;

  return {
    fontSize: `${size.md} !important`,
    fontWeight: 700,
    marginRight: pxToRem(-2.5),
    transform: () => {
      if (open) {
        return miniSidenav
          ? `translateX(${pxToRem(-24)}) rotate(0)`
          : "rotate(0)";
      }

      return miniSidenav
        ? `translateX(${pxToRem(-24)}) rotate(-180deg)`
        : "rotate(-180deg)";
    },
    // color: open ? dark.main : rgba(gradients.dark.state, 0.4),
    color: white.main,
    transition: transitions.create(["color", "transform"], {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.shorter,
    }),
  };
}

export { item, itemContent, itemArrow };
